var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup-div-iframe{background-color:rgba(0,0,0,0.6);display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;width:100vw;height:100vh}.popup-div-iframe .btn-close{background:url(" + escape(require("../../../assets/x-icon-popup.svg")) + ");width:19px;height:17px;position:absolute;top:60px;right:71px;border:none}.popup-div-iframe .btn-close:focus{outline:none}.popup-div-iframe-small-img{padding-top:30%;padding-left:22%}.popup-iframe{border:none;width:100%;height:100%}.popup-iframe-forms{background-color:white}.transparentDivPopup{background:transparent;position:fixed;top:0;left:0;width:100%;height:100%;opacity:.4;z-index:2}.mobile .btn-close{top:12px;right:52px;background-color:black}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/widget/components/popup/PopupFile.scss
// module id = 463
// module chunks = 0 1